<template>
    <v-expansion-panels>
        <v-expansion-panel
                v-for="mainCategory in subcategories"
                v-if="mainCategory.items"
                :key="mainCategory.systemName"
        >
            <v-expansion-panel-header>
                {{ mainCategory.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list dense>
                    <v-list-item
                            class="px-0"
                            v-for="subCategory in mainCategory.items"
                            v-if="subCategory.count"
                            :key="subCategory.systemName"
                            link
                            :to="subCategory.link"
                    >
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ subCategory.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                            <v-list-item-title>
                                {{ subCategory.count }}
                            </v-list-item-title>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    export default {
        name: "Subcategories",
        props:['subcategories']
    }
</script>

<style scoped>

</style>
